import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { InputIbsCbs } from '~/components/NovosInputs/InputIbsCbs';
import { useProduto } from '~/pages/Produto/hooks/useProduto';
import { SeparatorVertical, ContainerGrid } from './styles';
import { InputPercent, InputText } from '~/components/NovosInputs';
import Separator from '~/components/Separator';
import { DataGrid, GridColumns } from '@material-ui/data-grid';
import { formatCurrencyAsText } from '~/utils/functions';
import { rowsIbsProps } from '~/pages/Produto/types';

export const AbaIbsCbs: React.FC = () => {
  const {
    setValue,
    register,
    control,
    formState: { errors },
    rowsIBS,
    handleChangeRowsIBS,
    codIbsCbsRetriever,
  } = useProduto();

  const columns: GridColumns = [
    {
      field: 'des_sigla',
      headerName: 'UF',
      sortable: false,
      headerAlign: 'left',
      align: 'left',
      disableColumnMenu: true,
      width: 80,
    },
    {
      field: 'per_aliq_ibs_est',
      headerName: 'IBS Est.',
      sortable: false,
      headerAlign: 'right',
      align: 'right',
      disableColumnMenu: true,
      width: 230,
      renderCell: (row) => {
        const { per_aliq_ibs_est } = row.row;
        return <span>{formatCurrencyAsText(per_aliq_ibs_est)}</span>;
      },
    },
    {
      field: 'per_aliq_ibs_mun',
      headerName: 'IBS Mun.',
      sortable: false,
      headerAlign: 'right',
      align: 'right',
      disableColumnMenu: true,
      width: 230,
      renderCell: (row) => {
        const { per_aliq_ibs_mun } = row.row;
        return <span>{formatCurrencyAsText(per_aliq_ibs_mun)}</span>;
      },
    },
    {
      field: 'per_red_ibs',
      headerName: '% Red.',
      sortable: false,
      headerClassName: 'hideRightSeparator',
      headerAlign: 'right',
      align: 'right',
      disableColumnMenu: true,
      width: 235,
      renderCell: (row) => {
        const { per_red_ibs } = row.row;
        return <span>{formatCurrencyAsText(per_red_ibs)}</span>;
      },
    },
  ];

  const handleChangeClass = async (selected: rowsIbsProps) => {
    if (selected.value !== null) {
      await handleChangeRowsIBS(selected.value);
      setValue('cod_ibs_cbs', selected);
      setValue('per_aliq_cbs', formatCurrencyAsText(selected.per_aliq_cbs));
      setValue('per_red_cbs', formatCurrencyAsText(selected.per_red_cbs));
      return setValue('val_red_social', selected.val_red_social);
    }
    setValue('cod_ibs_cbs', { value: undefined, label: undefined });
    await handleChangeRowsIBS(null);
    setValue('per_aliq_cbs', '');
    setValue('per_red_cbs', '');
    setValue('val_red_social', 0);
  };

  return (
    <>
      <Col sm={12} md={12}>
        <InputIbsCbs
          label="IBS/CBS"
          name="cod_ibs_cbs"
          register={register}
          control={control}
          isError={!!errors.cod_ibs_cbs}
          changeSelected={async (selected) => {
            await handleChangeClass(selected);
          }}
          valueRetriever={codIbsCbsRetriever}
        />
      </Col>
      <Row>
        <Col sm={12} md={5}>
          <Separator labelText="CBS" />
          <Row>
            <Col xs="auto">
              <InputPercent
                label="Alíquota"
                placeholder="0,00"
                name="per_aliq_cbs"
                isError={false}
                register={register}
                control={control}
                disabled
                maxLength={6}
                max={100}
                min={0}
              />
            </Col>
            <Col xs="auto">
              <InputPercent
                label="Redução"
                placeholder="0,00"
                name="per_red_cbs"
                isError={false}
                disabled
                register={register}
                control={control}
                maxLength={6}
                max={100}
                min={0}
              />
            </Col>
          </Row>
          <Row>
            <Col xs="auto">
              <InputText
                label="Redutor Social"
                placeholder="0"
                alignRight
                name="val_red_social"
                isError={false}
                disabled
                register={register}
                control={control}
                maxLength={6}
                max={999999}
                min={0}
              />
            </Col>
          </Row>
        </Col>

        <Col md={1} style={{ width: '40px' }}>
          <SeparatorVertical />
        </Col>

        <Col style={{ minWidth: '55%' }}>
          <Separator labelText="IBS" />
          <ContainerGrid>
            <DataGrid
              className="grid"
              pageSize={3}
              rows={rowsIBS}
              columns={columns}
              autoHeight
              getRowId={(row) => row.des_sigla}
              disableColumnFilter
              disableColumnSelector
              disableColumnMenu
              disableSelectionOnClick
              localeText={{
                noRowsLabel: 'Nenhum registro encontrado....',
                columnMenuLabel: 'Menu',
                columnMenuFilter: 'Filtrar',
                columnMenuHideColumn: 'Esconder',
                columnMenuUnsort: 'Não ordenar',
                columnMenuSortAsc: 'Ordernar ASC',
                columnMenuSortDesc: 'Ordernar DESC',
                columnMenuShowColumns: 'Mostrar columnas',
              }}
            />
          </ContainerGrid>
        </Col>
      </Row>
    </>
  );
};
